import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { myFilesFolderCreate, myFilesFolderRename } from '../../../../../services/CommonService';

const FolderActionModal = ({
  modalState,
  onClose,
  userId,
  currentFolder,
  setRefreshTrigger,
  setSelectedItems,
  toast,
}) => {
  const [name, setName] = useState('');
  const [errors, setErrors] = useState({ name: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (modalState && modalState.visible) {
      setName(modalState.selectedItem ? (modalState.selectedItem.folder_name || modalState.selectedItem.file_name) : '');
      setErrors({ name: '' });
    }
  }, [modalState]);

  if (!modalState || !modalState.visible) return null;

  const { actionType, modalType, selectedItem } = modalState;

  const validateForm = () => {
    const newErrors = { name: '' };
    let isValid = true;
    if ((actionType === 'create' || actionType === 'rename') && !name.trim()) {
      newErrors.name = 'Name is required';
      isValid = false;
    }
    if (!userId) {
      newErrors.name = 'User ID is missing';
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };

  const handleAction = async () => {
    if (!validateForm()) return;
    setLoading(true);
    try {
      let payload;
      let response;
      let successMessage = '';
      switch (actionType) {
        case 'create':
          payload = {
            user_id: userId,
            folder_name: name,
            parent_id: currentFolder?.id || null,
          };
          response = await myFilesFolderCreate(payload);
          successMessage = 'Folder created successfully';
          break;
        case 'rename':
          payload = {
            user_id: userId,
            folder_id: modalType === 'folder' ? selectedItem.id : null,
            file_id: modalType === 'file' ? selectedItem.id : null,
            new_name: name,
          };
          response = await myFilesFolderRename(payload);
          successMessage = modalType === 'folder' ? 'Folder renamed successfully' : 'File renamed successfully';
          break;
        default:
          throw new Error('Invalid action type');
      }
      toast.success(response.data.message || successMessage);
      onClose();
      setRefreshTrigger(Date.now());
      if (actionType === 'rename') setSelectedItems([]);
    } catch (err) {
      toast.error(err.response?.data?.error || `Failed to ${actionType}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <div className="page-loading">
        <img src="/images/loader.gif" alt="loader" />
      </div>}
      <Modal show={modalState.visible} onHide={onClose}>
        <Modal.Header>
          <Modal.Title>
            {actionType === 'create' ? 'Create Folder' : `Rename ${modalType === 'folder' ? 'Folder' : 'File'}`}
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            onClick={onClose}
            aria-label="Close"
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-body-input-container">
            <label className="mb-1">{modalType === 'folder' ? 'Folder' : 'File'} Name</label>
            <input
              type="text"
              className={`modal-body-input rounded ${errors.name ? 'modal-body-input-error' : ''}`}
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder={`Enter ${modalType} name`}
              disabled={loading}
            />
            {errors.name && <div className="error-text">{errors.name}</div>}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAction} disabled={loading}>
            {loading ? (actionType === 'create' ? 'Creating...' : 'Saving...') : (actionType === 'create' ? 'Create' : 'Rename')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FolderActionModal; 